import day from 'dayjs'
// 格式化日期
export default type => {
    let startDate = new Date()
    let endDate = new Date()
    switch (type) {
        case 1: // 昨日
        case '1': // 昨日
            startDate.setDate(startDate.getDate() - 1)
            endDate = startDate
            break
        case 2:
        case '2':
            const week = startDate.getDay()
            if (week === 0) {
                // 星期天
                startDate.setDate(startDate.getDate() - 6)
            } else {
                startDate.setDate(startDate.getDate() - week + 1)
            }
            break
        case 3:
        case '3':
            startDate.setDate(1)
            break
        case 4:
        case '4':
            startDate.setMonth(0, 1)
            break
        default:
    }

    startDate.setHours(0, 0, 0)
    endDate.setHours(23, 59, 59)

    return [day(startDate).format('YYYY-MM-DD'),day(endDate).format('YYYY-MM-DD')]
}

export const formattedDate = type => {
    let startDate:any = new Date()
    let endDate:any = new Date()
    switch (type) {
        case 1: // 昨日
        case '1': // 昨日
            startDate.setDate(startDate.getDate() - 1)
            endDate = startDate
            break
        case 2:
        case '2':
           // 计算七天前的日期
            const sevenDaysAgo = new Date(startDate);
            sevenDaysAgo.setDate(startDate.getDate() - 6);
            endDate = new Date(startDate)
            startDate = new Date(sevenDaysAgo)

            break
        case 3:
        case '3':
            // 计算 30 天前的日期
            const thirtyDaysAgo = new Date(startDate);
            thirtyDaysAgo.setDate(startDate.getDate() - 29);
            endDate = new Date(startDate)
            startDate = new Date(thirtyDaysAgo)
            break
        case 4:
        case '4':
            startDate.setMonth(0, 1)
            break
        default:
    }

    startDate.setHours(0, 0, 0)
    endDate.setHours(23, 59, 59)

    return [day(startDate).format('YYYY-MM-DD'),day(endDate).format('YYYY-MM-DD')]
}